// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { css } from "styled-components";

productPriceStyles.price = {
    priceText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
    unitOfMeasureText: {
        ...fontConfig.singleLinexSmall,
    },
    vatLabelText: {
        ...fontConfig.singleLinexSmall,
    },
    signInText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
    errorText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
    realTimeText: {
        weight: fontConfig.weight.medium,
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
};

productPriceStyles.packLabelText = {
    ...fontConfig.singleLinexSmall,
    weight: fontConfig.weight.medium,
};

productPriceStyles.packDescriptionText = {
    ...fontConfig.singleLinexSmall,
};

productPriceStyles.packWrapper = {
    css: css`
        line-height: ${fontConfig.singleLinexSmall.lineHeight};
    `,
};

productPriceStyles.priceWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productPriceStyles.secondaryPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-top: 5px;
        ${wrapInContainerStyles}
    `,
};

productPriceStyles.secondaryPrice = {
    priceText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
    unitOfMeasureText: {
        ...fontConfig.singleLinexSmall,
    },
    vatLabelText: {
        ...fontConfig.singleLinexSmall,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            css: css`
                white-space: nowrap;
            `,
        },
    },
    signInText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
    errorText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
};

productPriceStyles.savingsMessageText = { italic: true, size: fontConfig.xSmall.size };

productPriceStyles.quoteMessageWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productPriceStyles.quoteMessage = {
    text: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            margin-bottom: 0;
        `,
    },
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText: {
        ...fontConfig.singleLinexSmall,
    },
};
